import { render, staticRenderFns } from "./CustomersBillingPreferenceColumn.vue?vue&type=template&id=00fb3ae4&"
import script from "./CustomersBillingPreferenceColumn.vue?vue&type=script&lang=js&"
export * from "./CustomersBillingPreferenceColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports